// src/Components/ToastProvider.jsx
import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from "react";
import { Snackbar, Alert } from "@mui/material";

const ToastContext = createContext();

// 🔹 global reference (NOT a hook)
let externalShowToast = null;

// 🔹 exported function usable anywhere
export const showGlobalToast = (message, severity = "error") => {
  externalShowToast?.(message, severity);
};

export function ToastProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");

  const showToast = useCallback((msg, sev = "success") => {
    setMessage(msg);
    setSeverity(sev);
    setOpen(true);
  }, []);

  // expose toast handler globally
  useEffect(() => {
    externalShowToast = showToast;
  }, [showToast]);

  const handleClose = (_, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}

      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity={severity}
          onClose={handleClose}
          sx={{ width: "100%", gap: "1rem", px: ".2rem" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </ToastContext.Provider>
  );
}

export const useToast = () => useContext(ToastContext);
